export class ForgetPasswordModel {
    public Email:string;
    public DomainUrl:string;
}
